(ns nosco.ui.page
  (:require
   [hx.react :refer [defnc]]))

(defnc PageHeader [{:keys [title subtitle badge text children]}]
  [:div {:class ["d-flex" "justify-content-between" "mt-2"]}
   [:div
    [:div
     [:h2 {:class ["h4" "d-inline-block"]} title]
     (when subtitle
       [:span {:class ["h5" "ml-3" "font-weight-normal" "text-muted"]}
        subtitle])
     (when badge
       [:span {:class ["ml-4" "badge" "badge-pill" "badge-secondary" "align-text-bottom"]}
        badge])]
    (when text [:div {:class ["text-muted"]} text])]
   [:div children]])
